import { CSSProperties } from 'react';
import { RegisterOptions, useFormContext } from 'react-hook-form';
import styles from 'styles/components/common/forms/FormTextarea.module.scss';

type TProps = {
  name: string;
  rule?: RegisterOptions;
  textareaStyle?: CSSProperties;
  placeholder?: string;
  readOnly?: boolean;
  maxLength?: number;
};

const FormTextarea = ({
  name,
  rule,
  textareaStyle,
  placeholder,
  readOnly,
  maxLength,
}: TProps) => {
  const { register } = useFormContext();

  return (
    <textarea
      {...register(name, rule)}
      style={textareaStyle}
      className={styles.textarea}
      placeholder={placeholder}
      readOnly={readOnly}
      maxLength={maxLength}
    ></textarea>
  );
};

export default FormTextarea;
